import React from 'react';
import styles from './PeriodSelectionFilterCard.module.scss';
import { CardDesign } from '../../../../../../components/CardDesign';
import { ReactComponent as DatePeriodIcon } from '../../../../../../resource/DatePeriodIcon.svg';
import { countValues } from '../../lib/countValues';
import FilterField from '../../../../shared/ui/FilterField/FilterField';
import { Select } from 'antd';
import {
  DatePickerCustom,
  enumTypePicker,
} from '../../../../../../components/DatePickerCustom';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { getOptionsByDateTypeFilter } from '../../lib/getOptionsByDateTypeFilter';
import { applyPermitFilter } from '../../../../shared/store/action';
import {
  SET_DATE_RANGE_FIELD_PERMIT_FILTER,
  SET_DATE_RANGE_PERMIT_FILTER,
} from '../../../../shared/store/types';

const PeriodSelectionFilterCard = () => {
  const dispatch = useDispatch();

  const { dateRangeField, dateRange, permitTypeId } = useSelector(
    (state) => state.permitsFilterStore
  );

  const optionsPeriodType = getOptionsByDateTypeFilter(permitTypeId);

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyPermitFilter(actionType)(value));
  };

  const handleChangeRangeDate = (value) => {
    makeChangeHandler(SET_DATE_RANGE_PERMIT_FILTER)(value);
  };

  const handleChangeDateRangeField = (value) => {
    makeChangeHandler(SET_DATE_RANGE_FIELD_PERMIT_FILTER)(value);
  };

  return (
    <CardDesign
      classname={cn(styles.card, {
        [styles.active]: countValues(dateRangeField, dateRange),
      })}
    >
      <CardDesign.Header
        heading="Период и выбор"
        icon={<DatePeriodIcon />}
        activeCount={countValues(dateRangeField, dateRange)}
      />

      <CardDesign.Body>
        <div className={styles.content}>
          <FilterField
            label="Выбор"
            active={!!dateRangeField}
          >
            <Select
              defaultActiveFirstOption={false}
              allowClear={false}
              placeholder="Выбор"
              notFoundContent="нет данных"
              value={dateRangeField}
              onChange={handleChangeDateRangeField}
              optionFilterProp="searchtext"
            >
              {optionsPeriodType?.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                >
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </FilterField>
          <FilterField
            label="Период"
            active={!!dateRange}
          >
            <DatePickerCustom
              value={dateRange}
              onChange={handleChangeRangeDate}
              typePicker={enumTypePicker.RANGE}
              size="large"
              placeholder={['ДД.ММ.ГГГГ', 'ДД.ММ.ГГГГ']}
              style={{ width: '100%' }}
              allowClear={false}
            />
          </FilterField>
        </div>
      </CardDesign.Body>
    </CardDesign>
  );
};

export default PeriodSelectionFilterCard;
